import React from 'react';
import { Header } from 'semantic-ui/semantic-ui-imports';
import { useTranslation } from 'react-i18next';
import Register from '../../components/Register';
import './index.scss';

const RegisterPage = () => {
  const { t } = useTranslation();

  return (
    <div className="register-page">
      <Header color="teal" className="register-page__header">
        {t('registerPage.header')}
      </Header>
      <Register />
    </div>
  );
};

export default RegisterPage;
